<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="时间节点" prop="timeNode">
                <a-select v-model="queryParam.timeNode" placeholder="请选择时间节点" allow-clear style="width: 100%">
                  <a-select-option :value="1">入院至术前</a-select-option>
                  <a-select-option :value="2">术后至出院前</a-select-option>
                  <a-select-option :value="3">出院时</a-select-option>
                  <a-select-option :value="4">出院后</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons" :style="{}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleQuery(record)" style="margin-right: 8px">
            <a-icon type="eye" />查看详情
          </a>
          <a @click="handleShowScoreChart(record)">
            <a-icon type="bar-chart" />查看评分统计
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 评分统计弹框 -->
    <a-modal
      title="评分统计"
      :visible="scoreChartVisible"
      :width="900"
      :footer="null"
      @cancel="scoreChartVisible = false"
      @afterVisibleChange="handleModalVisibleChange"
    >
      <div v-if="chartLoading" style="text-align: center; padding: 50px;">
        <a-spin size="large" />
      </div>
      <div v-else>
        <div ref="scoreChart" style="width: 100%; height: 400px;"></div>
      </div>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageUserRecord, delUserRecord, getTopData } from '@/api/biz/userRecord'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import * as echarts from 'echarts'

export default {
  name: 'UserRecord',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 评分统计弹框
      scoreChartVisible: false,
      chartLoading: false,
      chartData: null,
      scoreChart: null,
      // 查询参数
      queryParam: {
        nickname: null,
        mobile: null,
        timeNode: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '时间节点',
          dataIndex: 'timeNode',
          ellipsis: true,
          align: 'center',
          customRender(timeNode) {
            if (timeNode === 1) {
              return '入院至术前'
            } else if (timeNode === 2) {
              return '术后至出院前'
            } else if (timeNode === 3) {
              return '出院时'
            } else if (timeNode === 4) {
              return '出院后'
            }
            return '-'
          }
        },
        {
          title: '记录日期',
          dataIndex: 'recordDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  beforeDestroy () {
    // 组件销毁时清理图表和事件监听器
    if (this.scoreChart) {
      this.scoreChart.dispose()
      this.scoreChart = null
    }
    window.removeEventListener('resize', this.handleChartResize)
  },
  computed: {
  },
  watch: {
    scoreChartVisible (val) {
      if (!val) {
        // 弹框关闭时销毁图表和清理事件监听器
        if (this.scoreChart) {
          this.scoreChart.dispose()
          this.scoreChart = null
        }
        if (this.handleChartResize) {
          window.removeEventListener('resize', this.handleChartResize)
          this.handleChartResize = null
        }
      }
    }
  },
  methods: {
    /** 查询患者记录列表 */
    getList () {
      this.loading = true
      pageUserRecord(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      const hasSelected = that.ids && that.ids.length > 0
      const exportContent = hasSelected 
        ? `此操作将导出选中的 ${that.ids.length} 条数据` 
        : '此操作将导出当前条件下所有数据而非选中数据'
      
      this.$confirm({
        title: '是否确认导出?',
        content: exportContent,
        onOk () {
          const params = {
            ...that.queryParam
          }
          // 如果有选中的数据，将 ids 用逗号拼接成字符串传给接口
          if (hasSelected) {
            params.ids = that.ids.join(',')
          }
          that.download('biz/user-record/export', params, `患者记录${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        nickname: undefined,
        mobile: undefined,
        timeNode: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delSurveyAnswers(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 显示评分统计弹框 */
    handleShowScoreChart (record) {
      this.scoreChartVisible = true
      this.chartLoading = true
      this.chartData = null // 清空之前的数据
      // 调用接口获取数据
      getTopData({ id: record.id }).then(response => {
        this.chartData = response.data || []
        this.chartLoading = false
        // 延迟渲染，确保弹框 DOM 已渲染
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.scoreChartVisible && this.$refs.scoreChart) {
              this.renderChart(this.chartData)
            }
          }, 200)
        })
      }).catch(() => {
        this.chartLoading = false
        this.$message.error('获取评分统计数据失败')
      })
    },
    /** 弹框显示状态改变后的回调 */
    handleModalVisibleChange (visible) {
      if (visible && this.chartData && !this.chartLoading) {
        // 弹框完全显示后，确保 DOM 已渲染，再初始化图表
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.scoreChart && !this.scoreChart) {
              this.renderChart(this.chartData)
            }
          }, 200)
        })
      }
    },
    /** 渲染图表 */
    renderChart (data) {
      // 检查 DOM 元素是否存在
      if (!this.$refs.scoreChart) {
        console.warn('图表容器不存在，延迟渲染')
        return
      }
      
      // 时间节点映射
      const timeNodeMap = {
        1: '入院至术前',
        2: '术后至出院前',
        3: '出院时',
        4: '出院后'
      }
      
      // 处理数据：将 recordDate 和 timeNode 组合作为 x 轴
      const xAxisData = data.map((item, index) => {
        const timeNodeText = timeNodeMap[item.timeNode] || `时间节点${item.timeNode}`
        // 如果 recordDate 为 null，使用索引或时间节点作为标识
        if (item.recordDate) {
          return `${item.recordDate}-${timeNodeText}`
        } else {
          return `${timeNodeText}(${index + 1})`
        }
      })
      
      // y 轴数据（评分），过滤掉 null 值，显示为 0
      const scoreData = data.map(item => item.score != null ? item.score : 0)
      
      // 销毁旧图表
      if (this.scoreChart) {
        this.scoreChart.dispose()
        this.scoreChart = null
      }
      
      // 初始化图表
      this.scoreChart = echarts.init(this.$refs.scoreChart)
      
      // 配置选项
      const option = {
        title: {
          text: '评分统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            const param = params[0]
            return `${param.name}<br/>评分: ${param.value}`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            rotate: 45, // 旋转标签，避免重叠
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          name: '评分'
        },
        series: [
          {
            name: '评分',
            type: 'bar',
            data: scoreData,
            itemStyle: {
              color: '#1890ff'
            }
          }
        ]
      }
      
      // 设置配置项并渲染
      this.scoreChart.setOption(option)
      
      // 窗口大小改变时重新调整图表大小
      this.handleChartResize = () => {
        if (this.scoreChart) {
          this.scoreChart.resize()
        }
      }
      window.addEventListener('resize', this.handleChartResize)
    }
  }
}
</script>
